export default "__VITE_ASSET__CkB5c_S8__"